import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  temIdMarked: [],
  calculation: null,
  check_for_daily: false,
  updated_model: null,
  delete_model: null,
  change_value_input: null,
  selection_change_select2: null,
  indicate_route_change: null,
  total_global_invoices: 0,
  total_global_checks: 0,
  listen_show_row_detail: null,
  global_charger_axios: 0,
  with_object_cleaning: false,
  signature_generation_process: null,
  select_resource_signature_generation_process: null,
  updated_room: null,
}

// mutations
export const mutations = {
  [types.RUN_CALCULATIONS] (state, { hash }) {
    state.calculation = hash
  },
  [types.CHECK_FOR_DAILY] (state, { check }) {
    state.check_for_daily = check
  },
  [types.SET_UPDATE_STATUS] (state, model) {
    state.updated_model = model
  },
  [types.DELETE_MODEL] (state, model) {
    state.delete_model = model
  },
  [types.CHANGE_VALUE_INPUT] (state, model) {
    state.change_value_input = model
  },
  [types.SELECTION_CHANGE_SELECT2] (state, model) {
    state.selection_change_select2 = model
  },
  [types.INDICATE_ROUTE_CHANGE] (state, model) {
    state.indicate_route_change = model
  },
  [types.TOTAL_GLOBAL_INVOICES] (state, model) {
    state.total_global_invoices = model
  },
  [types.TOTAL_GLOBAL_CHECKS] (state, model) {
    state.total_global_checks = model
  },
  [types.SET_EMIT_SHOW_ROW_DETAIL] (state, model) {
    state.listen_show_row_detail = model
  },
  [types.GLOBAL_CHARGE_START] (state) {
    state.global_charger_axios = state.global_charger_axios + 1
  },
  [types.GLOBAL_CHARGE_SUCCESS] (state) {
    state.global_charger_axios = state.global_charger_axios - 1
  },
  [types.SET_GLOBAL_CHECK_ACTION] (state, payload) {
    state.temIdMarked = payload
  },
  [types.SET_WITH_OBJECT_CLEANING] (state, payload) {
    state.with_object_cleaning = payload.withObjectCleaning || false
  },
  [types.SET_SIGNATURE_GENERATION_PROCESS] (state, payload) {
    state.signature_generation_process = payload
  },
  [types.GET_SELECT_RESOURCE_SIGNATURE_GENERATION_PROCESS] (state, payload) {
    state.select_resource_signature_generation_process = payload
  },
  [types.SET_UPDATE_ROOM_STATUS] (state, payload) {
    state.updated_room = payload
  },
}

export const actions = {
  runCalculations ({ commit }, payload) {
    commit(types.RUN_CALCULATIONS, payload)
  },
  async runCheckForDaily ({ commit }, payload) {
    try {
      commit(types.CHECK_FOR_DAILY, { check: false })

      const { data } = await axios.post('/api/diarios/check/bitacora', payload)

      commit(types.CHECK_FOR_DAILY, { check: data })
    } catch (e) {
      console.warn(e)
    }
  },
  setUpdateStatus ({ commit }, payload) {
    commit(types.SET_UPDATE_STATUS, payload)
  },
  deleteModel ({ commit }, payload) {
    commit(types.DELETE_MODEL, payload)
  },
  changeValueInput ({ commit }, payload) {
    commit(types.CHANGE_VALUE_INPUT, payload)
  },
  selectionChangeSelect2 ({ commit }, payload) {
    commit(types.SELECTION_CHANGE_SELECT2, payload)
  },
  indicateRouteChange ({ commit }, payload) {
    commit(types.INDICATE_ROUTE_CHANGE, payload)
  },
  getTotalGlobalInvoices ({ commit }, payload) {
    commit(types.TOTAL_GLOBAL_INVOICES, payload)
  },
  getTotalGlobalChecks ({ commit }, payload) {
    commit(types.TOTAL_GLOBAL_CHECKS, payload)
  },
  emitShowRowDetail ({ commit }, payload) {
    commit(types.SET_EMIT_SHOW_ROW_DETAIL, payload)
  },
  globalCheckAction ({ commit }, payload) {
    commit(types.SET_GLOBAL_CHECK_ACTION, payload)
  },
  setWithObjectCleaning ({ commit }, payload) {
    commit(types.SET_WITH_OBJECT_CLEANING, payload)
  },
  signatureGenerationProcess ({ commit }, payload) {
    commit(types.SET_SIGNATURE_GENERATION_PROCESS, payload)
  },
  getSelectResourceSignatureGenerationProcess ({ commit }, payload) {
    commit(types.GET_SELECT_RESOURCE_SIGNATURE_GENERATION_PROCESS, payload)
  },
  setUpdateRoomStatus ({ commit }, payload) {
    commit(types.SET_UPDATE_ROOM_STATUS, payload)
  },
}

// getters
export const getters = {
  temIdMarked: state => state.temIdMarked,
  calculation: state => state.calculation,
  delete_model: state => state.delete_model,
  updated_model: state => state.updated_model,
  check_for_daily: state => state.check_for_daily,
  change_value_input: state => state.change_value_input,
  indicate_route_change: state => state.indicate_route_change,
  selection_change_select2: state => state.selection_change_select2,
  total_global_invoices: state => state.total_global_invoices,
  total_global_checks: state => state.total_global_checks,
  listen_show_row_detail: state => state.listen_show_row_detail,
  global_charger_axios: state => state.global_charger_axios,
  with_object_cleaning: state => state.with_object_cleaning,
  signature_generation_process: state => state.signature_generation_process,
  select_resource_signature_generation_process: state => state.select_resource_signature_generation_process,
  updated_room: state => state.updated_room,
}
